import { render, staticRenderFns } from "./RemoteVideo.vue?vue&type=template&id=55c1f8da&scoped=true"
import script from "./RemoteVideo.vue?vue&type=script&lang=js"
export * from "./RemoteVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c1f8da",
  null
  
)

export default component.exports